import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'src/app/shared/toasts/toast-service';
import { BudgetService } from '../../../../../services/budget.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { BudgetCategory } from '../../../../../models/budget-category.model';
import { ErrorMessagesService } from 'src/app/shared/messages/services/error-messages.service';

@Component({
  selector: 'app-budget-parameter-edit',
  templateUrl: './budget-parameter-edit.component.html',
  styleUrl: './budget-parameter-edit.component.scss'
})
export class BudgetParameterEditComponent implements OnInit {
  categoryForm!: FormGroup;
  breadCrumbItems: Array<{}> = [];
  loading: boolean = false;

  error = "";
  erro403 = false;

  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private budgetService: BudgetService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private errorMessagesService: ErrorMessagesService) {


    this.categoryForm = this.fb.group({
      id: [""],
      nome: ["", [Validators.required]],
      apresentarEmOrcamento: [false],
      tipoDeCalculo: ["", [Validators.required]],
      tipoDeApresentacao: ['1', Validators.required],
      tipoDeDespesa: ['1']
    });
  }

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: "Parâmetros Orçamento" },
      { label: "Editar", active: true },
    ];

    const id = this.route.snapshot.paramMap.get('id');

    this.loadForm(id!);
  }

  loadForm(id: string): void {
    this.budgetService.getCategoryById(id)
      .subscribe({
        next: (response) => {
          this.categoryForm.patchValue({
            id: response.id,
            nome: response.nome,
            apresentarEmOrcamento: !!response.apresentarEmOrcamento,
            tipoDeCalculo: response.tipoDeCalculo,
            tipoDeApresentacao: response.tipoDeApresentacao?.toString(),
            tipoDeDespesa: response.tipoDeDespesa?.toString()
          });
        },
        error: (error) => {

          if (error.status == 403) {
            this.erro403 = true;
            return;
          } 
          
          this.error = this.errorMessagesService.getMessage('ERR_00014');

          this.toastService.show("Erro ao tentar consultar categoria", {
            classname: "bg-danger text-light",
          });
        },
      });
  }

  onSubmit() {

    if (this.categoryForm.invalid) {
      this.categoryForm.markAllAsTouched();

      // Iterar sobre os campos e exibir os erros
      Object.keys(this.categoryForm.controls).forEach((field) => {
        const control = this.categoryForm.get(field);
        if (control?.errors) {
        }
      });

      return;
    }

    this.loading = true;

    var category = new BudgetCategory();

    category.id = this.categoryForm.get('id')?.value;
    category.nome = this.categoryForm.get('nome')?.value;
    category.apresentarEmOrcamento = this.categoryForm.get('apresentarEmOrcamento')?.value;
    category.tipoDeCalculo = parseInt(this.categoryForm.get('tipoDeCalculo')?.value);
    category.tipoDeApresentacao = this.categoryForm.get('apresentarEmOrcamento')?.value? parseInt(this.categoryForm.get('tipoDeApresentacao')?.value) : 0;
    category.tipoDeDespesa = parseInt(this.categoryForm.get('tipoDeDespesa')?.value)

    this.budgetService.updateBudgetcategory(category).subscribe({
      next: (data) => {

        this.toastService.show("Atualização com sucesso!", {
          classname: "bg-success text-light",
        });
        //this.categoryForm.reset();
        this.loading = false;
      },
      error: (err) => {
        this.toastService.show("Erro ao tentar atualizar documento!", {
          classname: "bg-danger text-light",
        });
        this.loading = false;
      }
    });
  }

  voltar() {
    this.location.back();
  }
}
